import { useHasPermission } from '../../hooks/useHasPermission';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';
import Iconify from '../Iconify';
import '../../css/roles/rolePageHeader.css';

const RolesPageHeader = ({ setOpenAddRole }) => {

    const { t } = useTranslation();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const hasRoleCreatePermission = useHasPermission('role_create');

    const handleAddRole = useCallback(() => {
        setOpenAddRole(true);
    }, [setOpenAddRole]);

    return (
        <Box className='role_page_header_main_container'>
            <Box className='role_page_header_title_box'>
                <Typography className='role_page_header_page_title'>{t("Rôles")}</Typography>
            </Box>
            {isDesktop && hasRoleCreatePermission &&
                <Box className='role_page_header_action_box' onClick={handleAddRole}>
                    <Iconify className='role_page_header_add_icon' icon={"ic:baseline-plus"} />
                    <Typography className='role_page_header_action_title'>{t("addRoleDialogeTitle")}</Typography>
                </Box>
            }
            {!isDesktop &&
                <Box className='role_page_header_action_box'>
                    {hasRoleCreatePermission && <Iconify className='role_page_header_add_icon' icon={"ic:baseline-plus"} onClick={handleAddRole} />}
                </Box>
            }
        </Box>
    );
};

export default React.memo(RolesPageHeader);